module.exports = "/_next/static/images/03cc1d6fd953d5c2757d4323ddbba339-nu-card-md@1x.jpg";